import { type ISupportedLanguage } from '#app/utils/i18n.tsx'

export class Collection {
	static readonly DRESS_CODE = new Collection('dress-code', {
		en: 'Dress Code',
		it: 'Dress Code',
		de: 'Dress Code',
		fr: 'Dress Code',
		es: 'Dress Code',
	})

	private constructor(
		public readonly code: string,
		public readonly labels: {
			en: string
			it: string
			de: string
			fr: string
			es: string
		},
	) {}

	static getAll(): Collection[] {
		return [this.DRESS_CODE]
	}

	static getSelectOptions(
		locale: ISupportedLanguage,
	): { value: string; label: string }[] {
		return this.getAll().map((profession) => ({
			value: String(profession.code),
			label: profession.labels[locale],
		}))
	}

	static getById(code: 'dress-code'): Collection | undefined {
		return this.getAll().find((profession) => profession.code === code)
	}
}
